module.exports = __webpack_public_path__ + "static/nader-4b08ea84c546c2f99c4be095d09ccff4.jpg";